import {instance} from "@/config/request.config";
import {TOKEN} from "@/constants";
import router from "@/router";

export function useRequest() {
    async function login(username, password) {
        try {
            const response = await instance.post("auth", {username, password});
            if (response) {
                localStorage.setItem(TOKEN, response.data.data.token);
                localStorage.setItem('authUser', JSON.stringify(response.data.data.loggedUser));
                localStorage.setItem('expirationLimit', response.data.data.expiresAt);

                return response
            }
        }
        catch(error) {
            return error.response
        }
    }

    async function logout() {
        //TODO: request logout from BE from logout monitoring
        try {
            localStorage.clear()
            await router.push({ name: 'index' });
        } catch(error) {
            console.error("Something went wrong");
        }
    }

    return {
        login,
        logout
    }
}